import { types, actions } from './requests'
export const DELETECLIENTORDER_TYPES = {
    ...types('DELETECLIENTORDER'),
}
export const DELETECLIENTORDER_ACTIONS = {
    ...actions('DELETECLIENTORDER'),
}
